'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';

import './Working.scss';

export default class Working extends Component {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.string,
        messages: PropTypes.arrayOf(PropTypes.string),
        rotateInterval: PropTypes.number,
    };

    static defaultProps = {
        rotateInterval: 3000,
    };

    state = {
        messageIndex: 0,
    };

    componentDidMount() {
        const { messages, rotateInterval } = this.props;

        if (messages && messages.length > 1) {
            this.rotateTimer = setInterval(() => {
                this.setState(prevState => ({
                    messageIndex: (prevState.messageIndex + 1) % messages.length,
                }));
            }, rotateInterval);
        }
    }

    componentWillUnmount() {
        if (this.rotateTimer) {
            clearInterval(this.rotateTimer);
        }
    }

    render() {
        const { title, message, messages } = this.props;
        const { messageIndex } = this.state;

        const displayMessage = messages && messages.length > 0
            ? messages[messageIndex]
            : message;

        return (
            <div className="patient-editor-working">
                <h2>{title}</h2>

                <i className="icon-spinner" />

                <p>{displayMessage}</p>
            </div>
        );
    }
}
